// 政策公告模块接口
import { get, post } from "@/utils/request";

//获取字典数据
export const dictType_list = function (type) {
  return get(`/system/dict/data/type/${type}`);
};
